import { getCountries } from "react-phone-number-input";

// Liste statique (codes ISO 3166-1 alpha-2 de react-phone-number-input, déjà
// une dépendance du portail) + noms localisés via Intl.DisplayNames : aucun
// appel réseau, donc aucun quota d'API consommé pour choisir un pays.

const optionsByLang = new Map();

const normalize = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim();

const safeLang = (lang) => {
  try {
    return Intl.DisplayNames.supportedLocalesOf([lang || "fr"])[0] || "fr";
  } catch {
    return "fr";
  }
};

/** Options { value: "FR", label: "France" } triées par nom localisé. */
export const getCountryOptions = (lang) => {
  const locale = safeLang(lang);
  if (!optionsByLang.has(locale)) {
    const names = new Intl.DisplayNames([locale], { type: "region" });
    const collator = new Intl.Collator(locale);
    optionsByLang.set(
      locale,
      getCountries()
        .map((code) => ({ value: code, label: names.of(code) || code }))
        .sort((a, b) => collator.compare(a.label, b.label))
    );
  }
  return optionsByLang.get(locale);
};

export const getCountryName = (code, lang) => {
  if (!code) return "";
  try {
    return new Intl.DisplayNames([safeLang(lang)], { type: "region" }).of(code.toUpperCase()) || code;
  } catch {
    return code;
  }
};

/**
 * Retrouve un code ISO depuis un code ("fr") ou un nom ("France", "Germany") :
 * l'API ne stocke qu'un code, mais d'anciennes données peuvent contenir un
 * nom saisi librement. Renvoie "" si rien ne correspond.
 */
export const findCountryCode = (input, lang) => {
  const raw = String(input || "").trim();
  if (!raw) return "";

  const upper = raw.toUpperCase();
  if (getCountries().includes(upper)) return upper;

  const needle = normalize(raw);
  const langs = [...new Set([lang, "fr", "en"])];
  for (const candidate of langs) {
    const hit = getCountryOptions(candidate).find((option) => normalize(option.label) === needle);
    if (hit) return hit.value;
  }
  return "";
};
